<template>
    <div
        class="loaderBloc"
        :style="{ width: width, height: height, 'background-color': color, position: fixed ? 'fixed' : 'absolute', top: top, left: left }"
        v-if="loading"
    >
        <div class="spinnerContainer" :style="{ top: spinTop, left: spinLeft, position: fixed ? 'fixed' : 'absolute' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                <path
                    fill="#C779D0"
                    d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z"
                >
                    <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                </path>
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="-65 10 200 80">
                    <path
                        d="M961.35,508.37l3.74-8.56H930.43V487.89h54.39l-9.29,20.48Zm.33,31.28a19,19,0,0,0-5.65-.77,21.75,21.75,0,0,0-9.32,2.19L952.06,529l7.08-16h14.19l-6.75,14.88-4.91,11.82m9.46-8.71a35.85,35.85,0,0,1,7.94,3.84,33.43,33.43,0,0,1-18.49,61.38,32.74,32.74,0,0,1-17.54-5,33.86,33.86,0,0,1-15.76-24.88h13.29a10.65,10.65,0,0,0,.41,3,20.21,20.21,0,0,0,3.22,6,21.28,21.28,0,0,0,5,4.66,20.93,20.93,0,0,0,11.38,3.29,20.41,20.41,0,0,0,8.08-1.64,21.47,21.47,0,0,0,6.64-4.37,20.56,20.56,0,0,0,4.46-22.66,20.76,20.76,0,0,0-4.46-6.62,21,21,0,0,0-6.64-4.45,22.64,22.64,0,0,0-2.22-.8Z"
                        transform="translate(-927.28 -487.89)"
                        fill="#C779D0"
                    />
                </svg>
            </svg>
        </div>
    </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
export default {
    components: { Spinner },
    props: {
        width: {
            default: "100%"
        },
        height: {
            default: "100%"
        },
        position: {
            default: "absolute"
        },
        color: {
            default: "rgba(255,255,255,0.3)"
        },
        spinTop: {
            default: "50%"
        },
        spinLeft: {
            default: "50%"
        },
        top: {
            default: "0px"
        },
        left: {
            default: "0px"
        },
        size: {
            default: "60"
        },
        loading: {
            required: true,
            default: false
        },
        fixed: {
            required: false,
            default: false
        }
    },
    name: "loader"
};
</script>

<style scoped lang="scss">
.loaderBloc {
    z-index: 2;
    .spinnerContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// loader.vue?eaa66d98